






















import { PropType, computed, defineComponent, ref } from '@vue/composition-api';
import { useAsyncState } from '@vueuse/core';
import { Message } from '../../dataType';
import FeedbackDialog from './FeedbackDialog.vue';
import { useMessage } from '../../hooks/useMessage';
import { useRootInstance } from '../../../common-module/src/util/useRootInstance';
import http from 'common-module/src/util/http';
type OperateType = 'like' | 'stamp' | 'clear';
export default defineComponent({
  name: 'ReactionMessage',
  components: {
    FeedbackDialog
  },
  props: {
    message: {
      type: Object as PropType<Message<any>>,
      required: true
    }
  },
  setup(props) {
    const visibleFeedback = ref<boolean>(false);
    const { updateMessage } = useMessage();
    const instance = useRootInstance();
    const { isLoading, execute } = useAsyncState((operateType: OperateType) => http.post('/chat/operate', {
      id: props.message.id,
      intentCode: props.message.intentCode || '',
      operateType
    }), null, { immediate: false });

    const isLike = computed(() => props.message.tag === 'like');
    const isFeedback = computed(() => props.message.tag === 'stamp');
    const updateMessageTag = (type: OperateType) => {
      updateMessage(props.message.id, {
        ...props.message,
        tag: type === 'clear' ? null : type
      }, false);
    };
    const operate = async (type: OperateType) => {
      await execute(0, type);
      updateMessageTag(type);
    };
    const handleFeedback = () => {
      if (isFeedback.value) {
        operate('clear');
        return;
      }
      visibleFeedback.value = true;
    };
    const handleFeedbackSubmit = (content: string) => {
      visibleFeedback.value = false;
      updateMessageTag('stamp');
      trackHelper('stamp', content);
    };
    const like = () => {
      operate(isLike.value ? 'clear' : 'like');
      if (!isLike.value) {
        trackHelper('like');
      }
    };

    const trackHelper = (type: 'like' | 'stamp', content?: string) => {
      const report = (props.message.content as any)?.report;
      const reportData = report?.reportData;
      const source = [];
      if (report?.base?.intentCode === 'knowledge_qa') {
        if (reportData.source?.doc?.length > 0) {
          source.push('doc');
        }
        if (reportData.source?.issue?.length > 0) {
          source.push('issue');
        }
      }
      instance.$track.send('WebIM_ResultFeedback', {
        Intent_Type: report?.base?.intentCode,
        Feedback_Result: type,
        Result_Type: reportData?.known_answer,
        AnswerSource_Type: source,
        Feedback_Type: content
      }, true);
    };

    return {
      visibleFeedback,
      handleFeedback,
      handleFeedbackSubmit,
      like,
      isLoading,
      isLike,
      isFeedback
    };
  }
});
